"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageContainer = void 0;
var Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
var CloseRounded_1 = __importDefault(require("@material-ui/icons/CloseRounded"));
var Publish_1 = __importDefault(require("@material-ui/icons/Publish"));
var react_1 = __importStar(require("react"));
var dialogs_1 = require("../dialogs");
var elements_1 = require("../elements");
var hooks_1 = require("../hooks");
var useWindowDimension_1 = require("../hooks/useWindowDimension");
var layout_1 = require("../layout");
var utils_1 = require("../utils");
var ImageCropDialog_1 = __importDefault(require("./ImageCropDialog"));
function ShowImage(_a) {
    var src = _a.src, alt = _a.alt, handleRemove = _a.handleRemove, upload = _a.upload, error = _a.error, label = _a.label;
    var _b = react_1.useState(false), hover = _b[0], setHover = _b[1];
    var windowDimensions = useWindowDimension_1.useWindowDimensions();
    if (!src) {
        return (react_1.default.createElement(ImageContainer, { error: error },
            react_1.default.createElement(UploadImageWithLabel, { label: label, hover: setHover, onChange: upload })));
    }
    if (windowDimensions.width && windowDimensions.width <= 600) {
        return (react_1.default.createElement(ImageContainer, { error: error },
            react_1.default.createElement(layout_1.APExpanded, null,
                react_1.default.createElement(layout_1.APStack, { style: { height: "100%", width: "100%" } },
                    react_1.default.createElement(layout_1.APAlign, { align: "fill" },
                        react_1.default.createElement(layout_1.APRow, { mainAxisAlignment: "center" },
                            react_1.default.createElement("img", { src: src, alt: alt, style: { maxHeight: "140px", maxWidth: "100%" } }))),
                    react_1.default.createElement(layout_1.APAlign, { align: "topRight" },
                        react_1.default.createElement("div", { style: { backgroundColor: "white", border: "2px solid grey", top: "-15px", right: "-15px", borderRadius: "50%", height: "28px" } },
                            react_1.default.createElement(CloseRounded_1.default, { htmlColor: "grey", fontSize: "default", onClick: handleRemove })))))));
    }
    return (react_1.default.createElement("div", { onMouseEnter: function (e) { return setHover(true); }, onMouseLeave: function (e) { return setHover(false); } }, hover ?
        react_1.default.createElement(ImageContainer, { error: error },
            react_1.default.createElement(layout_1.APExpanded, null,
                react_1.default.createElement(layout_1.APStack, { style: { height: "100%", width: "100%" } },
                    react_1.default.createElement(layout_1.APAlign, { align: "fill" },
                        react_1.default.createElement(layout_1.APRow, { mainAxisAlignment: "center" },
                            react_1.default.createElement("img", { src: src, alt: alt, style: { maxHeight: "140px", maxWidth: "100%" } }))),
                    react_1.default.createElement(layout_1.APAlign, { align: "center" },
                        react_1.default.createElement(layout_1.APRow, { crossAxisAlignment: "center", mainAxisSize: "min", style: { padding: "6px 10px", borderRadius: "20px", background: "white", fontWeight: 600 }, onClick: handleRemove },
                            react_1.default.createElement(Clear_1.default, null),
                            react_1.default.createElement(layout_1.APSizedBox, { width: "12px" }),
                            react_1.default.createElement("div", null, "Remove " + label),
                            react_1.default.createElement(layout_1.APSizedBox, { width: "8px" }))))))
        :
            react_1.default.createElement(ImageContainer, { error: error },
                react_1.default.createElement("img", { src: src, alt: alt, style: { maxHeight: "140px", maxWidth: "100%" } }))));
}
exports.default = ShowImage;
function ImageContainer(_a) {
    var children = _a.children, error = _a.error;
    return (react_1.default.createElement(layout_1.APColumn, { style: { padding: 12 } },
        react_1.default.createElement(layout_1.APExpanded, null,
            react_1.default.createElement(layout_1.APColumn, { mainAxisSize: "max", mainAxisAlignment: "center", crossAxisAlignment: "center", style: {
                    border: error !== null ? "4px dashed #ff1744" : "4px dashed #888",
                    height: "148px",
                    background: "#eee",
                    minHeight: "148px",
                    maxHeight: "148px",
                    width: "100%",
                    margin: "8px 0 0"
                } }, children)),
        react_1.default.createElement("div", { style: { color: "#ff1744", margin: "3px 14px 0", fontSize: "0.75rem", lineHeight: 1.66, letterSpacing: "0.0333em" } }, error !== null && error)));
}
exports.ImageContainer = ImageContainer;
function UploadImageWithLabel(_a) {
    var onChange = _a.onChange, hover = _a.hover, label = _a.label;
    var _b = hooks_1.useFilePicker(), files = _b.files, onClick = _b.onClick, HiddenFileInput = _b.HiddenFileInput, reset = _b.reset;
    var file = null;
    if (files)
        file = files[0];
    react_1.useEffect(function () {
        if (file) {
            getImageUrl(file);
        }
    }, [file]);
    function getImageUrl(selectedFile) {
        return __awaiter(this, void 0, void 0, function () {
            var base64, croppedBase64, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, convertBase64(selectedFile)];
                    case 1:
                        base64 = _a.sent();
                        return [4 /*yield*/, dialogs_1.launchDialog(function (deferred) { return react_1.default.createElement(ImageCropDialog_1.default, { deferred: deferred, base64: base64 }); }, true, true)
                            // var croppedBase64 = await launchDialog<string>(deferred => <ImageCropDialog deferred={deferred} base64={base64} />, true, true)
                        ];
                    case 2:
                        croppedBase64 = _a.sent();
                        // var croppedBase64 = await launchDialog<string>(deferred => <ImageCropDialog deferred={deferred} base64={base64} />, true, true)
                        onChange(croppedBase64);
                        hover(false);
                        reset();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        utils_1.handleErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    return (react_1.default.createElement(elements_1.APInkWell, { onClick: onClick },
        react_1.default.createElement(layout_1.APRow, { crossAxisAlignment: "center", mainAxisSize: "min", style: { padding: "6px 10px", borderRadius: "20px", background: "white", fontWeight: 600 } },
            react_1.default.createElement(Publish_1.default, null),
            react_1.default.createElement(layout_1.APSizedBox, { width: "12px" }),
            react_1.default.createElement("div", null, "Upload " + label),
            react_1.default.createElement(layout_1.APSizedBox, { width: "8px" }),
            react_1.default.createElement(HiddenFileInput, { accept: "image/*" }))));
}
var getBase64 = function (file) { return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () { return resolve(reader.result); };
    reader.onerror = function (error) { return reject(error); };
}); };
function convertBase64(file) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getBase64(file)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
